import { useEffect, useState } from "react";

import { updateCommissionSettings } from "../../services/settingsApi";

function CommissionSettings({ settings, reload }) {

    const [formData, setFormData] = useState({
        homeChef: "",
        restaurant: "",
        bakery: "",
        hotel: "",
    });

    useEffect(() => {

        if (settings) {

            setFormData({
                homeChef: settings.homeChef || "",
                restaurant: settings.restaurant || "",
                bakery: settings.bakery || "",
                hotel: settings.hotel || "",
            });

        }

    }, [settings]);

    const handleChange = (e) => {

        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });

    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        try {

            await updateCommissionSettings(formData);

            alert("Commission settings updated successfully.");

            reload();

        } catch (error) {

            console.error(error);

            alert("Failed to update commission settings.");

        }

    };

    return (

        <form
            className="settings-form"
            onSubmit={handleSubmit}
        >

            <div className="settings-card">

                <h2>Commission Settings</h2>

                <div className="settings-grid">

                    <div className="form-group">

                        <label>Home Chef Commission (%)</label>

                        <input
                            type="number"
                            name="homeChef"
                            value={formData.homeChef}
                            onChange={handleChange}
                            min="0"
                            max="100"
                        />

                    </div>

                    <div className="form-group">

                        <label>Restaurant Commission (%)</label>

                        <input
                            type="number"
                            name="restaurant"
                            value={formData.restaurant}
                            onChange={handleChange}
                            min="0"
                            max="100"
                        />

                    </div>

                    <div className="form-group">

                        <label>Bakery Commission (%)</label>

                        <input
                            type="number"
                            name="bakery"
                            value={formData.bakery}
                            onChange={handleChange}
                            min="0"
                            max="100"
                        />

                    </div>

                    <div className="form-group">

                        <label>Hotel Commission (%)</label>

                        <input
                            type="number"
                            name="hotel"
                            value={formData.hotel}
                            onChange={handleChange}
                            min="0"
                            max="100"
                        />

                    </div>

                </div>

                <button
                    type="submit"
                    className="save-btn"
                >
                    Save Commission Settings
                </button>

            </div>

        </form>

    );

}

export default CommissionSettings;